import React from 'react';

import {
  Col,
  Row,
} from 'antd';
import PropTypes from 'prop-types';

const ChatTime = ({ dateString }) => {
  return (
    <Row justify="center" gutter={[0, 7.5]}>
      <Col>
        <span className="chatTime">{dateString}</span>
      </Col>
    </Row>
  );
};

ChatTime.propTypes = {
  dateString: PropTypes.string,
};

export default ChatTime;
